import { Field } from '@/components/ui/field'
import { Input } from '@/components/ui/input'
import { useLinkAccount } from '@/hooks/useLinkAccount'

/**
 * Whose account a password is being set for, shown read-only in the form.
 *
 * In the form rather than only on the page: a password manager saves a new
 * password under the username field beside it. With only password boxes, it
 * saved a password with no account to it, or offered nothing, and the person
 * was back at the sign-in box with no saved login (planner feedback,
 * 2026-10-22). Nothing until the address is known; the submit is what refuses
 * a dead link.
 */
export function AccountEmailField({ token }: { token: string }) {
  const account = useLinkAccount(token)
  if (account.data === undefined) return null
  return (
    <Field label="Email" htmlFor="account-email">
      <Input id="account-email" type="email" autoComplete="username" value={account.data.email} readOnly />
    </Field>
  )
}
